<div class="assignation-actions-history">
  <div class="assignation-actions-history-header">
    <h2>Historique des actions</h2>

    <button class="actions-history-close-icon" (click)="close()">
      <img
        src="assets/icons/close-icon.svg"
        alt="close-icon"
        style="height: 15px; width: 50px"
      />
    </button>
  </div>
  <div
    *ngIf="!loadingActionsHistory"
    class="assignation-actions-history-content"
  >
    <div
      class="assignation-actions-history-content-row"
      *ngFor="let item of actionsHistory"
    >
      <div class="assignation-actions-history-content-row-action">
        {{ item.action }}
      </div>
      <div class="assignation-actions-history-content-row-other">
        <p>Auteur: {{ item.auteur }}</p>
        <p>Date: {{ item.date }}</p>
      </div>
    </div>
  </div>

  <div
    class="assignation-actions-history-loading-container"
    *ngIf="loadingActionsHistory"
  >
    <lib-little-bars-loader></lib-little-bars-loader>
  </div>
</div>
